import { sortOptionsISelect } from "../helpers/sortISelect";
import { InformationChannel } from "../model/enumerations/information-channel.model";

import { ISelect } from "../model/iSelect";

export const informationChannelEnum = (): Array<ISelect> => {
  const informationChannel: Array<ISelect> = [
    {
      label: "Portal de empleo",
      value: InformationChannel.EMPLOYEE_PORTAL,
    },
    {
      label: "Conocido / Referido",
      value: InformationChannel.KNOWN_REFERRED,
    },
    {
      label: "Redes Sociales (Linkedin, Facebook, Etc.)",
      value: InformationChannel.SOCIAL_MEDIA,
    },
    {
      label: "Otros",
      value: InformationChannel.OTHERS,
    },
  ];
  return sortOptionsISelect(informationChannel);
};
